import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TextField from '~/components/atoms/TextField.vue';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'SingleFieldForm',
  components: {
    GlobalRichText: GlobalRichText,
    GlobalTitle: GlobalTitle,
    TextField: TextField
  },
  props: {
    buttonText: {
      type: String,
      required: true
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    inputLabel: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      default: null
    },
    title: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      value: ''
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      this.$emit('submit', this.value);
    }
  }
};